import * as React from 'react';
import { TooltipHost, MaskedTextField, getTheme } from '@fluentui/react';
import { AdminContext } from 'Store/Admin';
import { TooltipText } from '../../shared';
import { validateRulesFieldValue } from 'components/util/validation';
import { ValidationMessage } from './ValidationMessage';
import { settingsFieldStyles } from '../SettingsStyles';
import { useEffect } from 'react';

interface ConfigFieldProps {
  config: PercentageConfig;
  label: string;
  tooltip: string;
}

export const enum PercentageConfig {
  CaseOpenLifetimeWarningFactor = 'caseOpenLifetimeWarningFactor'
}

export const ConfigPrecentageField: React.FC<ConfigFieldProps> = props => {
  const { palette, fonts } = getTheme();

  const { state, dispatch } = React.useContext(AdminContext);
  const [showError, setError] = React.useState<boolean>(false);
  const [value, setValue] = React.useState<string>('');

  useEffect(() => {
    if (state.queueDataState) {
      setValue(((state?.queueDataState?.caseOpenLifetimeWarningFactor || 0) * 100)?.toString());
    }
  }, [state.queueDataState]);

  const onComponentChange = (event): void => {
    let tmpValue: string = event.target.value.split('%')[0];
    tmpValue = tmpValue.replace(/ /g, '');
    if (tmpValue !== '0' && tmpValue !== '00' && tmpValue !== '') {
      tmpValue = String(validateRulesFieldValue(tmpValue, 1, 99));
      setError(false);
    } else {
      tmpValue = '0';
      setError(true);
    }
    dispatch({
      type: 'CASE_OPEN_LIFETIME_WARNING_FACTOR',
      payload: Number(tmpValue) / 100
    });
    dispatch({
      type: 'IS_UPDATED',
      payload: true
    });
    setValue(tmpValue);
  };

  const maskFormat: { [key: string]: RegExp } = {
    '*': /[0-9]/
  };

  return (
    <TooltipHost content={props.tooltip}>
      <MaskedTextField
        className="ms-Grid-col"
        id={props.config}
        label={props.label}
        value={value}
        onChange={(e): void => onComponentChange(e)}
        mask="**%"
        maskFormat={maskFormat}
        maskChar=" "
        styles={settingsFieldStyles(palette, fonts, 60)}
      />
      {showError && <ValidationMessage message={TooltipText.validationPercentageMessage} fonts={fonts} />}
    </TooltipHost>
  );
};
